import React from "react";
import {
    Box,
    Typography
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { BlockOutlined } from "@mui/icons-material";
import moment from "moment";
import ReactTooltip from "react-tooltip";


const StepContent = ({ date, status, description }) => (
    <Box
        sx={{
            backgroundColor: "#e3f2fd",
            display: "flex",
            padding: 1,
            height: 54,
            borderRadius: 2,
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #1976d2",
        }}
    >
        <Box
            sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
        >
            <BlockOutlined fontSize="small" sx={{ color: "#1976d2" }} />

            <InfoIcon
                fontSize="small"
                sx={{ color: "#1976d2" }}
                data-for="info"
                data-tip={description || "Sem descrição."}
            />
        </Box>

        <Box sx={{ flex: 1, marginLeft: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {moment(date).format("DD/MM/YYYY [às] HH:mm")}
            </Typography>
            <Typography variant="body2">{status}</Typography>
        </Box>

        <ReactTooltip
            id="info"
            place="top"
            className='custom-color'
            backgroundColor='#155BCB'
        />
    </Box>
);

export default StepContent;